export default __webpack_public_path__ + "static/media/childDevelopmnet-blob6.66e46088.svg";